import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { API_CONFIG } from './api.config';

@Injectable({ providedIn: 'root' })
export class ApiService {
  constructor(private http: HttpClient) {}

  private baseUrl(endpoint: { path: string; version: string }) {
    return `${API_CONFIG.BASE_URL}/${endpoint.version}${endpoint.path}`;
  }

  get<T>(
    endpoint: { path: string; version: string },
    options?: any,
  ): Observable<T> {
    return this.http.get<T>(this.baseUrl(endpoint), options) as Observable<T>;
  }

  post<T>(
    endpoint: { path: string; version: string },
    body: any,
    options?: any,
  ): Observable<T> {
    return this.http.post<T>(
      this.baseUrl(endpoint),
      body,
      options,
    ) as Observable<T>;
  }

  put<T>(
    endpoint: { path: string; version: string },
    body: any,
    options?: any,
  ): Observable<T> {
    return this.http.put<T>(
      this.baseUrl(endpoint),
      body,
      options,
    ) as Observable<T>;
  }

  patch<T>(
    endpoint: { path: string; version: string },
    body: any,
    options?: any,
  ): Observable<T> {
    return this.http.patch<T>(
      this.baseUrl(endpoint),
      body,
      options,
    ) as Observable<T>;
  }

  delete<T>(
    endpoint: { path: string; version: string },
    options?: any,
  ): Observable<T> {
    return this.http.delete<T>(
      this.baseUrl(endpoint),
      options,
    ) as Observable<T>;
  }
}
